export default "__VITE_PUBLIC_ASSET__460e0653__"